import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9340_8761)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M41.5649 41.5703C50.7165 32.4188 50.7165 17.5812 41.5649 8.42969C32.4134 -0.721844 17.5758 -0.721845 8.42432 8.42969C-0.727214 17.5812 -0.727214 32.4188 8.42432 41.5703C17.5758 50.7218 32.4134 50.7218 41.5649 41.5703Z",
					fill: "#87B668"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.2473 38.2527C45.5666 30.9334 45.5666 19.0666 38.2473 11.7473C30.9281 4.42806 19.0612 4.42806 11.7419 11.7473C4.42269 19.0666 4.42269 30.9334 11.7419 38.2527C19.0612 45.5719 30.9281 45.5719 38.2473 38.2527Z",
					fill: "#97C877"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18.6411 25.8065L22.5101 29.3595C23.0744 29.879 23.9479 29.8514 24.4787 29.3041L31.381 22.6956C31.9424 22.1558 31.9594 21.2626 31.4193 20.7009C30.8793 20.14 29.9866 20.1225 29.4252 20.6623L23.4465 26.3866L20.5524 23.7291C19.9791 23.2016 19.0858 23.2386 18.558 23.8125C18.0303 24.3858 18.0675 25.2785 18.6411 25.8065ZM24.9999 11.415C32.5027 11.415 38.5848 17.4971 38.5848 24.9999C38.5848 32.5027 32.5027 38.5848 24.9999 38.5848C17.4971 38.5848 11.415 32.5027 11.415 24.9999C11.415 17.4971 17.4971 11.415 24.9999 11.415Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9340_8761",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
